import { render, staticRenderFns } from "./FbaPlan.vue?vue&type=template&id=500beb00&scoped=true"
import script from "./FbaPlan.vue?vue&type=script&lang=js"
export * from "./FbaPlan.vue?vue&type=script&lang=js"
import style0 from "./FbaPlan.vue?vue&type=style&index=0&id=500beb00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500beb00",
  null
  
)

export default component.exports